import { createSlice } from "@reduxjs/toolkit";
import { Achievement , AchievementState} from "./achievementTypes";
import { fetchachievemnetById ,createachievemnet } from "./achievementAction";


const initialState: AchievementState = {
  achievement: [],
  selectedachievement: undefined,
  loadingStates: {
    create: false,
    update: false,
    delete: false,
    fetchById: false,
    fetchAll: false,
  },
  errors: {
    create: undefined,
    update: undefined,
    delete: undefined,
    fetchById: undefined,
    fetchAll: undefined,
  },
};

const achievementSlice = createSlice({
  name: "appraisal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchachievemnetById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchachievemnetById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedachievement = action.payload;
      })
      .addCase(fetchachievemnetById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })
      
    .addCase(createachievemnet.pending, (state) => {
                                       state.loadingStates.create = true;
                                       state.errors.create = undefined;
                                 })
                                   .addCase(createachievemnet.fulfilled, (state, action) => {
                                       state.loadingStates.create = false;
                                       state.achievement.push(action.payload);
                                   })
                                   .addCase(createachievemnet.rejected, (state, action) => {
                                       state.loadingStates.create = false;
                                       state.errors.create = action.payload as string;
                                   })
  },
});

export default achievementSlice.reducer;